/**
 * AgeOption is a constant object that provides a set of predefined age filter options with corresponding labels and values.
 *
 * The available options include:
 *   - LastDay: Filter by data from the last day with a value of 1.
 *   - Last3Days: Filter by data from the last 3 days with a value of 3.
 *   - Last7Days: Filter by data from the last 7 days with a value of 7.
 *   - Last14Days: Filter by data from the last 14 days with a value of 14.
 *   - Last28Days: Filter by data from the last 28 days with a value of 28.
 *   - AllTime: Show all data.
 *
 * @typedef {{label: string, value: number}} MaxAgeFilter
 * @type {Readonly<{[key: string]: MaxAgeFilter}>}
 * @enum
 */
export const MaxAgeOption = Object.freeze({
    LastDay: { label: 'Last day', value: 1 },
    Last3Days: { label: 'Last 3 days', value: 3 },
    Last7Days: { label: 'Last 7 days', value: 7 },
    Last14Days: { label: 'Last 14 days', value: 14 },
    Last28Days: { label: 'Last 28 days', value: 28 },
    AllTime: { label: 'All time', value: null }
});
